module.exports = "<p-fieldset [style]=\"{height: '100%'}\">\r\n  <p-header style=\"color: white\">\r\n    <i style=\"font-size: 1.5em\" class=\"{{ icon }}\"></i>\r\n    {{ titulo || 'Sem Titulo'}}\r\n  </p-header>\r\n  <section class=\"ui-g\" style=\"display: flex; justify-content: center\">\r\n    <div class=\" ui-g ui-g-12 ui-fluid\">\r\n      <ng-content></ng-content>\r\n    </div>\r\n  </section>\r\n</p-fieldset>"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/area-restrita/shared/layout/body-fieldset/panel-generico.component.html
// module id = ../../../../../src/app/area-restrita/shared/layout/body-fieldset/panel-generico.component.html
// module chunks = main